import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import FlagIcon from '@mui/icons-material/Flag';

const FlagButton = ({ flagged, onToggle, size = 'small' }) => (
    <Tooltip title={flagged ? 'Unflag question' : 'Flag for review'}>
        <IconButton onClick={onToggle} size={size} sx={{ color: flagged ? '#f59e0b' : 'text.secondary' }}>
            {flagged ? <FlagIcon /> : <FlagOutlinedIcon />}
        </IconButton>
    </Tooltip>
);

export default FlagButton;
